import Vue from "vue";
import VueRouter from "vue-router";
import { isLoggedIn } from '@/middleware/auth'

import UserLogin from "@/components/UserLogin.vue";
import ForgotPassword from "@/components/ForgotPassword.vue";
import ResetPassword from "@/components/ResetUserPassword.vue";
import PageNotFound from "@/components/UserPageNotFound.vue";
import ServerErrorPage from "@/components/UserPageServerError.vue";
import AuthorizedErrorPage from "@/components/UserPageAuthorized.vue";
import UserDashboard from "@/components/UserDashboard.vue";
import UserProfile from "@/components/users/Profile.vue";
import ChangePassword from "@/components/users/ChangePassword.vue";
import ContactUs from "@/components/support/ContactUs.vue";

import IndexTesting from "@/components/testing/Index.vue";
import MapsTesting from "@/components/testing/maps.vue";

import Users from "@/components/administration/users/Users.vue";
import UsersAdd from "@/components/administration/users/UsersAdd.vue";
import UsersEdit from "@/components/administration/users/UsersEdit.vue";
import UsersDetail from "@/components/administration/users/UsersDetail.vue";

import Company from "@/components/administration/company/Company.vue";
import CompanyAdd from "@/components/administration/company/CompanyAdd.vue";
import CompanyDetail from "@/components/administration/company/CompanyDetail.vue";
import CompanyEdit from "@/components/administration/company/CompanyEdit.vue";
import CompanyUpload from "@/components/administration/company/CompanyUpload.vue";

import Role from "@/components/administration/role/Role.vue";
import RoleAdd from "@/components/administration/role/RoleAdd.vue";
import RoleDetail from "@/components/administration/role/RoleDetail.vue";
import RoleEdit from "@/components/administration/role/RoleEdit.vue";
import RoleUpload from "@/components/administration/role/RoleUpload.vue";


import Permission from "@/components/administration/permission/Permission.vue";
import PermissionAdd from "@/components/administration/permission/PermissionAdd.vue";
import PermissionDetail from "@/components/administration/permission/PermissionDetail.vue";
import PermissionEdit from "@/components/administration/permission/PermissionEdit.vue";
import PermissionUpload from "@/components/administration/permission_role/PermissionUpload.vue";



import PermissionRole from "@/components/administration/permission_role/PermissionRole.vue";
import PermissionRoleAdd from "@/components/administration/permission_role/PermissionRoleAdd.vue";
import PermissionRoleEdit from "@/components/administration/permission_role/PermissionRoleEdit.vue";
import PermissionRoleDetail from "@/components/administration/permission_role/PermissionRoleDetail.vue";

// import Location from "@/components/administration/Location.vue";


import AlertSetting from "@/components/dasboard-ct/alertSetting/AlertSetting.vue";
import AlertSettingAdd from "@/components/dasboard-ct/alertSetting/AlertSettingAdd.vue";
import AlertSettingDetail from "@/components/dasboard-ct/alertSetting/AlertSettingDetail.vue";
import AlertSettingEdit from "@/components/dasboard-ct/alertSetting/AlertSettingEdit.vue";
import AlertSettingUpload from "@/components/dasboard-ct/alertSetting/AlertSettingUpload.vue";

import TemplateOrder from "@/components/orders/template-order/TemplateOrder.vue";
import TemplateOrderAdd from "@/components/orders/template-order/TemplateOrderAdd.vue";
import TemplateOrderDetail from "@/components/orders/template-order/TemplateOrderDetail.vue";
import TemplateOrderEdit from "@/components/orders/template-order/TemplateOrderEdit.vue";
import TemplateOrderUpload from "@/components/orders/template-order/TemplateOrderUpload.vue";


import TransportOrder from "@/components/orders/transport-order/TransportOrder.vue";
import TransportOrderAdd from "@/components/orders/transport-order/TransportOrderAdd.vue";
import TransportOrderDetail from "@/components/orders/transport-order/TransportOrderDetail.vue";
import TransportOrderEdit from "@/components/orders/transport-order/TransportOrderEdit.vue";
import TransportOrderUpload from "@/components/orders/transport-order/TransportOrderUpload.vue";

import routesDriver from "@/components/master/driver/routes";
import routesCommodity from "@/components/master/commodity/routes";
import routesLocation from "@/components/master/location/routes";
import routesArea from "@/components/master/area/routes";

import routesBusinessUnit from "@/components/master/business_unit/routes";
import routesInputForecast from "@/components/sales-forecast/input-forecast/routes";
import routesApprovalForecast from "@/components/sales-forecast/approval-forecast/routes";
import routesViewForecast from "@/components/sales-forecast/view-forecast/routes";
import routesoutstanding from "@/components/sales-forecast/outstanding-member/routes";
import routesreportforecastsales from "@/components/sales-forecast/forecast-report-sales/routes";
import routesreportforecastarea from "@/components/sales-forecast/forecast-report-area/routes";
import routesreportforecastcustomer from "@/components/sales-forecast/forecast-report-customer/routes";
import routesCustomer from "@/components/master/customer/routes";
import routesForecastDate from "@/components/master/forecast_date/routes";
import routesSales from "@/components/master/sales/routes";
import routesSalesApproval from "@/components/master/sales_approval/routes";
import routesPackage from "@/components/master/package/routes";
import routesPostalCode from "@/components/master/postal_code/routes";
import routesRegion from "@/components/master/region/routes";
import routesSKU from "@/components/master/sku/routes";
import routesSystemCode from "@/components/master/system_code/routes";
import routesTruck from "@/components/master/truck/routes";
import routesBranch from "@/components/master/branch/routes";
import routesTypeDocument from "@/components/master/type_document/routes";
import routesDocument from "@/components/master/document/routes";
import routesCustomerCT from "@/components/master/customerCT/routes";
import routesStatus from "@/components/master/status/routes";
import routesStopLocation from "@/components/master/stop_location/routes";
import routesLeadTime from "@/components/master/lead_time/routes";


import routesFakturPajak from "@/components/dasboard-fp/faktur_pajak/routes";
import routesTransportOrderCT from "@/components/orders/control-tower/routes";



import Driver from "@/components/master/driver/Index";
import Truck from "@/components/master/truck/Index";
import Commodity from "@/components/master/commodity/Index";
import Location from "@/components/master/location/Index";
import Area from "@/components/master/area/Index";

import BusinessUnit from "@/components/master/business_unit/Index";
import InputForecast from "@/components/sales-forecast/input-forecast/Index";
import ApprovalForecast from "@/components/sales-forecast/approval-forecast/Index";
import ViewForecast from "@/components/sales-forecast/view-forecast/Index";
import OutstandingMember from "@/components/sales-forecast/outstanding-member/Index";
import ForecastReportSales from "@/components/sales-forecast/forecast-report-sales/Index";
import ForecastReportArea from "@/components/sales-forecast/forecast-report-area/Index";
import ForecastReportCustomer from "@/components/sales-forecast/forecast-report-customer/Index";
import Customer from "@/components/master/customer/Index";
import ForecastDate from "@/components/master/forecast_date/Index";
import Sales from "@/components/master/sales/Index";
import SalesApproval from "@/components/master/sales_approval/Index";
import Package from "@/components/master/package/Index";
import PostalCode from "@/components/master/postal_code/Index";
import Region from "@/components/master/region/Index";
import SKU from "@/components/master/sku/Index";
import SystemCode from "@/components/master/system_code/Index";
import Branch from "@/components/master/branch/Index";
import TypeDocument from "@/components/master/type_document/Index";
import Document from "@/components/master/document/Index";
import CustomerCT from "@/components/master/customerCT/Index";
import Status from "@/components/master/status/Index";
import StopLocation from "@/components/master/stop_location/Index";
import LeadTime from "@/components/master/lead_time/Index";

import DashboardCT from "@/components/dasboard-ct/dashboard.vue";
import TripAlert from "@/components/dasboard-ct/tripAlert.vue";
import DocAlert from "@/components/dasboard-ct/docAlert.vue";
import ServiceAlert from "@/components/dasboard-ct/serviceAlert.vue";
import OntimeAnalysis from "@/components/dasboard-ct/onTimeAnalysis.vue";
import DetailMonitoring from "@/components/dasboard-ct/detailmonitoring.vue";

import DashboardFP from "@/components/dasboard-fp/dashboard.vue";
import FakturPajak from "@/components/dasboard-fp/faktur_pajak/Index";
import TransportOrderCT from "@/components/orders/control-tower/Index";

import DashboardGT from "@/components/dasboard-gt/dashboard.vue";
import UserMappingGT from "@/components/dasboard-gt/user-mapping/Index";
import routesUserMappingGT from "@/components/dasboard-gt/user-mapping/routes";
import PoolDetailGT from "@/components/dasboard-gt/poolDetail.vue";
import BranchDetailGT from "@/components/dasboard-gt/branchDetail.vue";
import poolTransactions from "@/components/dasboard-gt/poolTransactions.vue";
import branchTransactions from "@/components/dasboard-gt/branchTransactions.vue";
import TransactionDetail from "@/components/dasboard-gt/TransactionDetail.vue";
import allBranchTransactions from "@/components/dasboard-gt/allBranchTransactions.vue";
import NewsPortalGT from "@/components/dasboard-gt/news-portal/Index";
import routesNewsPortalGT from "@/components/dasboard-gt/news-portal/routes";


import MasterSales from "@/components/master-sales/mastersales.vue";

Vue.use(VueRouter);

const routes = [

  /**
   * Testing
   */
   {
    path: '/mastersales',
    meta: {
      title: "Sales System",
      allowAnonymous: true
    },
    name: "MasterSales",
    component: MasterSales
  },






  {
    path: '/coba',
    meta: {
      title: "Sales System",
      allowAnonymous: true
    },
    name: "IndexTesting",
    component: IndexTesting
  },

  {
    path: '/mapstesting',
    meta: {
      title: "Sales System",
      allowAnonymous: true
    },
    name: "MapsTesting",
    component: MapsTesting
  },

  {
    path: "/",
    meta: {
      title: "Sales System",
      allowAnonymous: true
    },
    name: "UserLogin",
    component: UserLogin
  },
  {
    path: "/forgot-password",
    meta: {
      title: "Sales System",
      allowAnonymous: true
    },
    name: "ForgotPassword",
    component: ForgotPassword
  },
  {
    path: "/reset-password/:email/:token",
    meta: {
      title: "Sales System",
      allowAnonymous: true
    },
    name: "ResetPassword",
    component: ResetPassword,
    props: true
  },
  {
    path: '/server-error',
    meta: {
      title: "Sales System",
      allowAnonymous: true
    },
    name: "ServerErrorPage",
    component: ServerErrorPage
  },
  {
    path: '/authorized-error',
    meta: {
      title: "Sales System",
      allowAnonymous: true
    },
    name: "AuthorizedErrorPage",
    component: AuthorizedErrorPage
  },
  {
    path: '/page-not-found',
    meta: {
      title: "Sales System",
      allowAnonymous: true
    },
    name: "PageNotFound",
    component: PageNotFound
  },
  {
    path: '*',
    meta: {
      title: "Sales System"
    },
    name: "PageNotFoundArea",
    component: PageNotFound
  },
  {
    path: '/dashboard',
    meta: {
      title: "Sales System",
    },
    name: "UserDashboard",
    component: UserDashboard
  },

  {
    path: '/monitoring/detail/:id/:vehicle_no/:gps_vendor',
    meta: {
      title: "Sales System",
    },
    name: "DetailMonitoring",
    component: DetailMonitoring
  },

  {
    path: '/dashboard-gt',
    meta: {
      title: "Sales System",
    },
    name: "DashboardGT",
    component: DashboardGT
  },

  {
    path: '/dashboard-ct',
    meta: {
      title: "Sales System",
    },
    name: "DashboardCT",
    component: DashboardCT
  },

  {
    path: '/trip-alert',
    meta: {
      title: "Sales System",
    },
    name: "TripAlert",
    component: TripAlert
  },

  {
    path: '/ontime-analysis',
    meta: {
      title: "Sales System",
    },
    name: "OntimeAnalysis",
    component: OntimeAnalysis
  },


  {
    path: '/service-alert',
    meta: {
      title: "Sales System",
    },
    name: "ServiceAlert",
    component: ServiceAlert
  },

  {
    path: '/doc-alert',
    meta: {
      title: "Sales System",
    },
    name: "DocAlert",
    component: DocAlert
  },

  /**
   * Tax Invoice
   */
  {
    path: '/dashboard-fp',
    meta: {
      title: "Tax Invoice",
    },
    name: "DashboardFP",
    component: DashboardFP
  },

  /**
   * User
   */
  {
    path: '/profile',
    meta: {
      title: "Sales System",
    },
    name: "UserProfile",
    component: UserProfile
  },
  {
    path: '/change-password',
    meta: {
      title: "Sales System",
    },
    name: "ChangePassword",
    component: ChangePassword
  },


  /**
   * Support
   */
  {
    path: '/contact-us',
    meta: {
      title: "Sales System",
    },
    name: "ContactUs",
    component: ContactUs
  },


  /**
   * Administration/Users
   */
  {
    path: '/users',
    meta: {
      title: "Sales System",
    },
    name: "Users",
    component: Users
  },
  {
    path: '/users/add',
    meta: {
      title: "Sales System",
    },
    name: "UsersAdd",
    component: UsersAdd
  },

  {
    path: '/users/edit/:id',
    meta: {
      title: "Sales System",
    },
    name: "UsersEdit",
    component: UsersEdit
  },


  {
    path: '/users/detail/:id',
    meta: {
      title: "Sales System",
    },
    name: "UsersDetail",
    component: UsersDetail
  },


  /**
   * Administration/Company
   */

   {
    path: '/status',
    meta: {
      title: "Sales System",
    },
    children:routesStatus,
    component: resolve => resolve(Status),
  },

  {
    path: '/stop-location',
    meta: {
      title: "Sales System",
    },
    children:routesStopLocation,
    component: resolve => resolve(StopLocation),
  },



  {
    path: '/lead-time',
    meta: {
      title: "Sales System",
    },
    children:routesLeadTime,
    component: resolve => resolve(LeadTime),
  },



   {
    path: '/type-document',
    meta: {
      title: "Sales System",
    },
    children:routesTypeDocument,
    component: resolve => resolve(TypeDocument),
  },

  {
    path: '/dok',
    meta: {
      title: "Sales System",
    },
    children:routesDocument,
    component: resolve => resolve(Document),
  },

  {
    path: '/master-customer-ct',
    meta: {
      title: "Sales System",
    },
    children:routesCustomerCT,
    component: resolve => resolve(CustomerCT),
  },

  {
    path: '/driver',
    meta: {
      title: "Sales System",
    },
    children:routesDriver,
    component: resolve => resolve(Driver),
  },
  {
    path: '/truck',
    meta: {
      title: "Sales System",
    },
    children:routesTruck,
    component: resolve => resolve(Truck),
  },
  {
    path: '/company',
    meta: {
      title: "Sales System",
    },
    name: "Company",
    component: Company
  },
  {
    path: '/company/add',
    meta: {
      title: "Sales System",
    },
    name: "CompanyAdd",
    component: CompanyAdd
  },

  {
    path: '/company/edit/:id',
    meta: {
      title: "Sales System",
    },
    name: "CompanyEdit",
    component: CompanyEdit
  },

  {
    path: '/company/detail/:id',
    meta: {
      title: "Sales System",
    },
    name: "CompanyDetail",
    component: CompanyDetail
  },


  {
    path: '/company/upload',
    meta: {
      title: "Sales System",
    },
    name: "CompanyUpload",
    component: CompanyUpload
  },

  /**
   * Administration/Role
   */
  {
    path: '/role',
    meta: {
      title: "Sales System",
    },
    name: "Role",
    component: Role
  },


  {
    path: '/role/add',
    meta: {
      title: "Sales System",
    },
    name: "RoleAdd",
    component: RoleAdd
  },

  {
    path: '/role/edit/:id',
    meta: {
      title: "Sales System",
    },
    name: "RoleEdit",
    component: RoleEdit
  },

  {
    path: '/role/detail/:id',
    meta: {
      title: "Sales System",
    },
    name: "RoleDetail",
    component: RoleDetail
  },


  {
    path: '/role/upload',
    meta: {
      title: "Sales System",
    },
    name: "RoleUpload",
    component: RoleUpload
  },



  /**
   * Administration/Permission
   */
  {
    path: '/permission',
    meta: {
      title: "Sales System",
    },
    name: "Permission",
    component: Permission
  },

  {
    path: '/permission/add',
    meta: {
      title: "Sales System",
    },
    name: "PermissionAdd",
    component: PermissionAdd
  },

  {
    path: '/permission/edit/:id',
    meta: {
      title: "Sales System",
    },
    name: "PermissionEdit",
    component: PermissionEdit
  },

  {
    path: '/permission/detail/:id',
    meta: {
      title: "Sales System",
    },
    name: "PermissionDetail",
    component: PermissionDetail
  },


  {
    path: '/permission/upload',
    meta: {
      title: "Sales System",
    },
    name: "PermissionUpload",
    component: PermissionUpload
  },



  /**
   * Administration/Permission
   */
  {
    path: '/rolpermis',
    meta: {
      title: "Sales System",
    },
    name: "Permission Role",
    component: PermissionRole
  },

  {
    path: '/rolpermis/add',
    meta: {
      title: "Sales System",
    },
    name: "PermissionRoleAdd",
    component: PermissionRoleAdd
  },

  {
    path: '/rolpermis/edit/:id',
    meta: {
      title: "Sales System",
    },
    name: "PermissionRoleEdit",
    component: PermissionRoleEdit
  },

  {
    path: '/rolpermis/detail/:id',
    meta: {
      title: "Sales System",
    },
    name: "PermissionRoleDetail",
    component: PermissionRoleDetail
  },

  /**
   * Master/Region
   */
  {
    path: '/region',
    meta: {
      title: "Sales System",
    },
    children:routesRegion,
    component: Region
  },


  /**
   * Master/Package
   */
  {
    path: '/package',
    meta: {
      title: "Sales System",
    },
    children:routesPackage,
    component: Package
  },

  /**
   * Master/PostalCode
   */
  {
    path: '/postal-code',
    meta: {
      title: "Sales System",
    },
    children:routesPostalCode,
    component: PostalCode
  },
  /**
   * Master/SystemCode
   */
  {
    path: '/system-code',
    meta: {
      title: "Sales System",
    },
    children: routesSystemCode,
    component: SystemCode
  },

  /**
 * Master/Commodity
 */
  {
    path: '/commodity',
    meta: {
      title: "Sales System",
    },
    children:routesCommodity,
    component: Commodity
  },


  {
    path: '/branch',
    meta: {
      title: "Sales System",
    },
    children:routesBranch,
    component: Branch
  },

  /** Tax Invoice */

  {
    path: '/faktur-pajak',
    meta: {
      title: "Tax Invoice",
    },
    children:routesFakturPajak,
    component: FakturPajak
  },



  /** Control Tower Orders */

  {
    path: '/ct-orders',
    meta: {
      title: "Orders Control Tower",
    },
    children:routesTransportOrderCT,
    component: TransportOrderCT
  },

       /**
 * Order/Transport
 */
    {
      path: '/order/transport-template',
      meta: {
        title: "Sales System",
      },
      name: "TemplateOrderIndex",
      component: TemplateOrder
    },

    {
      path: '/order/transport-template/add',
      meta: {
        title: "Sales System",
      },
      name: "TemplateOrderAdd",
      component: TemplateOrderAdd
    },

    {
      path: '/order/transport-template/upload',
      meta: {
        title: "Sales System",
      },
      name: "TemplateOrderUpload",
      component: TemplateOrderUpload
    },


    {
      path: '/order/transport-template/edit/:id',
      meta: {
        title: "Sales System",
      },
      name: "TemplateOrderEdit",
      component: TemplateOrderEdit
    },

    {
      path: '/order/transport-template/detail/:id',
      meta: {
        title: "Sales System",
      },
      name: "TemplateOrderDetail",
      component: TemplateOrderDetail
    },
  
       /**
 * Order/Transport Order
 */
        {
          path: '/order/transport-order',
          meta: {
            title: "Sales System",
          },
          name: "TransportOrderIndex",
          component: TransportOrder
        },
    
        {
          path: '/order/transport-order/add',
          meta: {
            title: "Sales System",
          },
          name: "TransportOrderAdd",
          component: TransportOrderAdd
        },
    
        {
          path: '/order/transport-order/upload',
          meta: {
            title: "Sales System",
          },
          name: "TransportOrderUpload",
          component: TransportOrderUpload
        },
    
    
        {
          path: '/order/transport-order/edit/:id',
          meta: {
            title: "Sales System",
          },
          name: "TransportOrderEdit",
          component: TransportOrderEdit
        },
    
        {
          path: '/order/transport-order/detail/:id',
          meta: {
            title: "Sales System",
          },
          name: "TransportOrderDetail",
          component: TransportOrderDetail
        },
      

  /**
* Master/SKU
*/
  {
    path: '/sku',
    meta: {
      title: "Sales System",
    },
    children:routesSKU,
    component: SKU
  },
  /**
* Master/Location
*/
  {
    path: '/location',
    meta: {
      title: "Sales System",
    },
    children:routesLocation,
    component: Location
  },

    /**
* Master/Area
*/
{
  path: '/area',
  meta: {
    title: "Sales System",
  },
  children:routesArea,
  component: Area
},

    /**
* Input Forecast
*/
{
  path: '/input-forecast',
  meta: {
    title: "Sales System",
  },
  children:routesInputForecast,
  component: InputForecast
},

  /**
* Approval Forecast
*/
{
  path: '/approval-forecast',
  meta: {
    title: "Sales System",
  },
  children:routesApprovalForecast,
  component: ApprovalForecast
},

/**
* view Forecast
*/
{
  path: '/view-forecast',
  meta: {
    title: "Sales System",
  },
  children:routesViewForecast,
  component: ViewForecast
},

/**
* outstanding Member
*/
{
  path: '/outstanding-member',
  meta: {
    title: "Sales System",
  },
  children:routesoutstanding,
  component: OutstandingMember
},

/**
* forecast report
*/
{
  path: '/forecast-report-sales',
  meta: {
    title: "Sales System",
  },
  children:routesreportforecastsales,
  component: ForecastReportSales
},

{
  path: '/forecast-report-area',
  meta: {
    title: "Sales System",
  },
  children:routesreportforecastarea ,
  component: ForecastReportArea 
},

{
  path: '/forecast-report-customer',
  meta: {
    title: "Sales System",
  },
  children:routesreportforecastcustomer ,
  component: ForecastReportCustomer 
},

 /**
* Master/Business Unit
*/
{
  path: '/business_unit',
  meta: {
    title: "Sales System",
  },
  children:routesBusinessUnit,
  component: BusinessUnit 
},

/**
* Master/Customer
*/
{
  path: '/customer',
  meta: {
    title: "Sales System",
  },
  children:routesCustomer,
  component: Customer 
},


/**
* Master/Forecast Date
*/
{
  path: '/forecast_date',
  meta: {
    title: "Sales System",
  },
  children:routesForecastDate,
  component: ForecastDate 
},

/**
* Master/Sales
*/
{
  path: '/sales',
  meta: {
    title: "Sales System",
  },
  children:routesSales,
  component: Sales 
},

/**
* Master/Sales Approval
*/
{
  path: '/sales_approval',
  meta: {
    title: "Sales System",
  },
  children:routesSalesApproval,
  component: SalesApproval 
},
/**
* Alert Setting
*/
{
  path: '/alert-setting',
  meta: {
    title: "Sales System",
  },
  name: "AlertSetting",
  component: AlertSetting
},
{
  path: '/alert-setting/add',
  meta: {
    title: "Sales System",
  },
  name: "AlertSettingAdd",
  component: AlertSettingAdd
},

{
  path: '/alert-setting/edit/:id',
  meta: {
    title: "Sales System",
  },
  name: "AlertSettingEdit",
  component: AlertSettingEdit
},

{
  path: '/alert-setting/detail/:id',
  meta: {
    title: "Sales System",
  },
  name: "AlertSettingDetail",
  component: AlertSettingDetail
},

{
  path: '/alert-setting/upload',
  meta: {
    title: "Sales System",
  },
  name: "AlertSettingUpload",
  component: AlertSettingUpload
},

  /** GT */

  {
    path: '/gt/user-mapping',
    meta: {
      title: "User Mapping",
    },
    children:routesUserMappingGT,
    component: UserMappingGT
  },
   
  {
    path: '/gt/pool-dashboard/:id',
    meta: {
      title: "Pool Detail",
    },
    component: PoolDetailGT
  },
   
  {
    path: '/gt/branch-dashboard/:id',
    meta: {
      title: "Branch Detail",
    },
    component: BranchDetailGT
  },
   
  {
    path: '/gt/pool-transactions/:id',
    meta: {
      title: "Pool Transactions",
    },
    component: poolTransactions
  },
   
  {
    path: '/gt/branch-transactions/:id',
    meta: {
      title: "Branch Transactions",
    },
    component: branchTransactions
  },
   
  {
    path: '/gt/transaction/detail/:id',
    meta: {
      title: "Transaction Detail",
    },
    component: TransactionDetail
  },
   
  {
    path: '/gt/all-branch-transactions',
    meta: {
      title: "All Branch Transactions",
    },
    component: allBranchTransactions
  },
  {
    path: '/gt/news-portal',
    meta: {
      title: "News Portal",
    },
    children:routesNewsPortalGT,
    component: NewsPortalGT
  },
   
  
  
];

const router = new VueRouter({
  mode: "history",
  routes
});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  document.title = to.meta.title;

  if (to.name == 'UserLogin' && isLoggedIn() || to.name == 'ForgotPassword' && isLoggedIn() || to.name == 'ResetPassword' && isLoggedIn()) {

    //var userModel = JSON.parse(localStorage.getItem("userModels"));

    next({ path: '/dashboard' });

    // if (userModel.sub.role.name == 'root_ct') {
    //   next({ path: '/dashboard-ct' })
    // } else if (userModel.sub.role.name == 'root_faktur_pajak' && userModel.sub.role.name == 'user_faktur_pajak') {
    //   next({ path: '/dashboard-fp' })
    // } else {
    //   next({ path: '/dashboard' })
    // }

  }
  else if (!to.meta.allowAnonymous && !isLoggedIn()) {
    next({
      path: '/',
      query: { redirect: to.fullPath }
    })
  }
  else {
    next()
  }
});


export default router;
